import { render } from "./conflict-of-intrest-policy.vue?vue&type=template&id=741efc84"
import script from "./conflict-of-intrest-policy.vue?vue&type=script&lang=js"
export * from "./conflict-of-intrest-policy.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__